<template>
    <div class="gh-page gh-page--mcd">
        <section class="gh-section">
            <div class="container">
                <h1 class="gh-section__heading">{{ documentData.heading }}</h1>
                <p>{{ leadingText }}</p>
            </div>
        </section>

        <section class="gh-section gh-section--form">
            <div class="container">
                <component :is="documentComponent" :event-type="eventType"></component>
            </div>
        </section>
    </div>
</template>

<script>
    import store from '../store';
    import documentMixin from '../mixins/document';

    export default {
        mixins: [documentMixin],

        components: {
            ghFormCertificate: () => import(/* webpackChunkName: "event.document" */ './FormCertificate.vue'),
            ghFormInvoice: () => import(/* webpackChunkName: "event.document" */ './FormInvoice.vue')
        },

        computed: {
            documentComponent() {
                return this.documentData.component
            },

            leadingText() {
                if (this.eventType === 'masterclass') {
                    return `Thank you for attending a Mental Health Academy Masterclass. ${this.documentData.helperText}`;
                }

                return `Thank you for attending a Mental Health Academy online Summit. ${this.documentData.helperText}`;
            }
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (! vm.validType || ! vm.validDocument) {
                    vm.$router.replace('/');
                }
            });
        },

        created() {
            !this.$store.state.eventDocument && this.$store.registerModule('eventDocument', store);
        },
    }
</script>

<style lang="scss" scoped>
    .gh-section--form {
        padding-top: 0;
        margin-top: -36px;
    }
</style>
